/**
 * @file checkboxでの項目表示／非表示
 */
'use strict';
import Common from '../../Utils/Common';

/**
 * @classname ToggleRadio
 * @classdesc checkboxでの項目表示／非表示
 */
export default class ToggleRadio {
	/**
	 * @constructor
	 * @param {jQuery} $e - [data-checkbox-toggle=true]
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		this._$e = $e;
		this._value = $e.attr('data-value');
		this._$openTarget = $($e.attr('data-open-target')) || null;
		this._$closeTarget = $($e.attr('data-close-target')) || null;
		this._name = $e.attr('name');
		this._$e.on('click', () => this.onClick());
		this.onClick();
	};


	/**
	 * Clickのコールバック
	 *
	 * @memberof ToggleRadio
	 * @return {undefined}
	 */
	onClick() {
		console.log(`${this.constructor.name}.onClick`);
		const selected = $(`[name=${this._name}]:checked`).val();
		console.log(`${selected} / ${this._value}`);
		console.log(`${this._$e.attr('name')} / ${$('#ob-og-wrap').css('style')}`)
		if (this._$e.attr('name') === 'mutual_aid_old_member_requested' && $('#ob-og-wrap').css('display') === 'none') return;
		if (selected == this._value) {
			this._$openTarget.show().find('.validate').removeClass('ignore-validate');
			if (this._$closeTarget) Common.addIgnoreValidate(this._$closeTarget);
		} else {
			this._$closeTarget.show().find('.validate').removeClass('ignore-validate');
			if (this._$openTarget) Common.addIgnoreValidate(this._$openTarget);
		}
	}
}
